import React from 'react';
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Switch,
  SwitchProps,
  Text,
  // useColorModeValue,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';

interface SwitchInputFormProps extends SwitchProps {
  name: string | undefined | any;
  label: string | undefined;
  onClick?: any;
  errors: any;
  control: any;
  subLabel?: string;
}

export const SwitchInputForm = ({
  name,
  label,
  onClick,
  errors,
  control,
  subLabel,
  ...rest
}: SwitchInputFormProps) => {
  const { onChange: externalOnChange, ...switchProps } = rest;

  return (
    <FormControl isInvalid={!!errors[name]} mb={5}>
      <FormLabel fontWeight="bold" htmlFor={name}>
        {label}
      </FormLabel>
      <Flex align="center" mb={2}>
        <Text>{!subLabel ? 'Ativo ?' : subLabel}</Text>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Switch
              {...switchProps}
              size="lg"
              ml={3}
              colorScheme="button.primary"
              dropShadow="0px 3px 6px #00000065"
              onChange={e => {
                field.onChange(e.target.checked);
                if (typeof externalOnChange === 'function') {
                  externalOnChange(e);
                }
                if (onClick) {
                  onClick();
                }
              }}
              isChecked={!!field.value}
            />
          )}
        />
      </Flex>
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
